import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Menu Icon from Figma
 * @link [Figma](https://www.figma.com/file/bUeKiC8YcV9PHrMlJAZUJG/Design-System?type=design&node-id=769-26346&mode=dev)
 * */
const MenuIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path className="fill-current" d="M6 3a1 1 0 100-2 1 1 0 000 2zM6 7a1 1 0 100-2 1 1 0 000 2zM6 11a1 1 0 100-2 1 1 0 000 2z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MenuIcon;